/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
const is = require("is_js");

const SERVICE_NAME = "WeatherAnalyticsService";
const log: any = LoggerModule.getInstance();

export class WeatherAnalyticsPageService {
  private static instance: WeatherAnalyticsPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): WeatherAnalyticsPageService {
    if (!WeatherAnalyticsPageService.instance) {
      WeatherAnalyticsPageService.instance = new WeatherAnalyticsPageService(
        props
      );
    }
    return WeatherAnalyticsPageService.instance;
  }
  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }
  public resetCriteria() {
    this.criteria = [];
  }
  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  // public async getPageContent() {
  //   let content: any = {};
  //   let compProps: any = null;
  //   const agent = getAgent();

  //   //Header Props
  //   compProps = await agent.getHeaderProps({});
  //   if (compProps) {
  //     content = { ...content, ...compProps };
  //   }

  //    //graph data
  //    compProps = await agent.getWeatherAnalyticsProps({})
  //    if(compProps){
  //      content = {...content, ...compProps}
  //    }

  //    //activity list

  //    compProps =await agent.getActivityListProps({})
  //    if(compProps) {
  //      content = {...content, ...compProps}
  //    }

  //   // //Main Props
  //   // compProps = await agent.getMainSectionProps({});
  //   // if (compProps) {
  //   //   content = { ...content, ...compProps };
  //   // }

  //   //Feature Section Props
  //   compProps = await agent.getFeatureSectionProps({});
  //   if (compProps) {
  //     content = { ...content, ...compProps };
  //   }

  //   //Footer Props
  //   compProps = await agent.getFooterProps({});
  //   if (compProps) {
  //     content = { ...content, ...compProps };
  //   }

  //   return content;
  // }

  public async getAnalytics(args:any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    // if (args?.where) {
    //   this.setCriteria(args?.where);
    // }

    //graph data
    compProps = await agent.getWeatherAnalyticsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //activity list

    // compProps =await agent.getActivityListProps({})
    // if(compProps) {
    //   content = {...content, ...compProps}
    // }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  // public formatPolicyDetail(args: any) {
  //   const agent = getAgent();
  //   return agent.getFormatPolicyDetailSync(args);
  // }

  // public formatTimeLineDetail(args:any) {
  //   const agent = getAgent();
  //   return agent.getFormatTimelineDetailSync(args);
  // }
}
